import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_DEV_RATES_WIDGET_TYPE_ID} from './dex-dev-rates-widget-type-id';
import {DexDevRatesWidgetComponent} from './dex-dev-rates-widget.component';
import {DexDevRatesWidgetImplementation} from './dex-dev-rates-widget.implementation';
import {DexDevRatesWidgetSettingsComponent} from './settings/dex-dev-rates-widget-settings.component';
import {DexDevRatesWidgetSettingsService} from './settings/dex-dev-rates-widget-settings.service';

export const DEX_DEV_RATES_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_DEV_RATES_WIDGET_TYPE_ID,
    widgetLabel:               'Rates',
    widgetImplementationType:  DexDevRatesWidgetImplementation,
    widgetComponentType:       DexDevRatesWidgetComponent,
    widgetSettingsServiceType: DexDevRatesWidgetSettingsService,
    settingsSchema:            [
        {
            name:        'title',
            isShareable: false
        },
        {
            name:        'columns',
            isShareable: false
        }
    ],
    hasGroupingSupport:          false,
    widgetSettingsComponentType: DexDevRatesWidgetSettingsComponent
};
